// Dados detalhados dos serviços extraídos do portfólio

export const servicesData = {
  'devops-as-a-service': {
    id: 'devops-as-a-service',
    title: 'DevOps As a Service',
    subtitle: 'Acelere entregas com automação e arquiteturas modernas',
    description: 'Implementação e gestão de práticas DevOps para acelerar entregas, melhorar qualidade e reduzir custos.',
    
    challenges: [
      'Baixa frequência de deploy e ciclos longos de entrega',
      'Falhas recorrentes em produção',
      'Dificuldade de escalar aplicações e ambientes',
      'Complexidade de gestão em cenários multi-cloud ou híbridos'
    ],
    
    deliverables: [
      'Pipelines de CI/CD automatizados',
      'Estratégia e implementação de containers e Kubernetes',
      'Infraestrutura como Código (Terraform, Ansible, etc.)',
      'Implementação de GitOps',
      'Padrões de observabilidade e runbooks'
    ],
    
    whenMakesSense: [
      'Times que querem reduzir lead time e aumentar previsibilidade de releases',
      'Aplicações que precisam de escalabilidade e resiliência',
      'Organizações com múltiplos ambientes e necessidade de padronização',
      'Iniciativas de adoção de microserviços, containers e Kubernetes'
    ],
    
    results: [
      'Entregas mais rápidas e frequentes com menor risco',
      'Redução de incidentes em produção',
      'Ambientes reproduzíveis e auditáveis',
      'Maior eficiência operacional'
    ],

    faq: [
      {
        question: 'Quando contratar DevOps as a Service?',
        answer: 'Quando a empresa precisa acelerar releases, reduzir falhas em produção, padronizar ambientes ou implantar CI/CD, infraestrutura como código, containers e Kubernetes sem sobrecarregar o time interno.'
      },
      {
        question: 'DevOps substitui a equipe de desenvolvimento?',
        answer: 'Não. A Sua Nuvem atua como parceira técnica para estruturar automação, governança e operação, trabalhando junto com desenvolvimento, segurança e infraestrutura.'
      }
    ]
  },

  'cloud-privada': {
    id: 'cloud-privada',
    title: 'Cloud Privada',
    subtitle: 'Controle total da sua infraestrutura em nuvem',
    description: 'Soluções em cloud privada da Sua Nuvem. Flexibilidade da nuvem pública com controle total da privada. Ideal para empresas que buscam soberania de dados, personalização e custos previsíveis, sem abrir mão dos benefícios da nuvem.',
    
    // Novos campos para estrutura detalhada
    serviceTypes: [
      {
        title: 'Sua Nuvem - Infraestrutura como Serviço (IaaS)',
        subtitle: 'Sua empresa pode utilizar nossa plataforma Sua Nuvem',
        description: 'Sua empresa pode operar dentro da Sua Nuvem, uma plataforma completa de Infraestrutura como Serviço (IaaS) projetada para oferecer alta performance, segurança avançada e total controle operacional.',
        features: [
          'Infraestrutura dedicada e isolada em ambiente cloud',
          'Recursos computacionais sob demanda (CPU, RAM, Storage e Rede)',
          'Suporte técnico especializado 24/7',
          'Backups automatizados e disaster recovery',
          'Custos previsíveis sem surpresas na fatura',
          'Escalabilidade sob demanda',
          'SLA de 99,9% de disponibilidade garantida'
        ]
      },
      {
        title: 'Nuvem White Label',
        subtitle: 'Podemos construir uma nuvem para você (Sua Nuvem com White Label)',
        description: 'Cloud privada completa com sua marca. Ideal para ISPs, provedores e empresas de hosting que desejam oferecer serviços de cloud IaaS aos seus clientes. Infraestrutura totalmente customizável, gerenciada pela Sua Nuvem com sua identidade visual.',
        features: [
          'Plataforma cloud completa com sua marca',
          'Painel de controle personalizado',
          'Integração com sistemas de billing existentes',
          'Suporte técnico white-label para seus clientes',
          'Gestão completa de infraestrutura pela Sua Nuvem',
          'Modelo de receita recorrente para seu negócio'
        ]
      }
    ],
    
    // Detalhes técnicos Apache CloudStack
    cloudStackFeatures: {
      compute: {
        title: 'Compute',
        icon: 'Server',
        services: [
          {
            name: 'Virtual Machines',
            subtitle: 'Flexibilidade, desempenho e controle',
            description: 'Implante e gerencie máquinas virtuais para suportar cargas de trabalho diversas com alto desempenho e confiabilidade.',
            features: [
              'Escalabilidade para desenvolvimento, teste e produção',
              'Segurança e integração com redes e serviços',
              'Proteção de dados e continuidade operacional',
              'Suporte multi-hypervisor (KVM, VMware, XenServer, XCP-ng)'
            ]
          },
          {
            name: 'Kubernetes (CKS)',
            subtitle: 'Orquestração eficiente e escalável de containers',
            description: 'Automatize a implantação, o gerenciamento e a escalabilidade de aplicações em containers.',
            features: [
              'Alta disponibilidade e balanceamento de carga',
              'Performance e resiliência garantidas',
              'Gerenciamento simplificado',
              'Integração nativa com serviços de rede, armazenamento e segurança'
            ]
          },
          {
            name: 'Container Registry',
            subtitle: 'Armazenamento efetivo e distribuição de imagens',
            description: 'Gerencie, armazene e distribua imagens de containers de forma segura e escalável.',
            features: [
              'Integração nativa com Kubernetes',
              'Segurança aprimorada com verificação de vulnerabilidades',
              'Controle de acesso baseado em permissões',
              'Otimização do fluxo de desenvolvimento'
            ]
          }
        ]
      },
      storage: {
        title: 'Storage',
        icon: 'Database',
        services: [
          {
            name: 'Block Storage',
            subtitle: 'Desempenho e confiabilidade para seus dados',
            description: 'Armazenamento de alto desempenho para cargas de trabalho exigentes, como bancos de dados e aplicações críticas.',
            features: [
              'Escalabilidade sob demanda',
              'Flexibilidade para crescer conforme necessidade',
              'Segurança avançada com criptografia',
              'Snapshots e backups automatizados'
            ]
          },
          {
            name: 'Object Storage',
            subtitle: 'Escalabilidade e resiliência para grandes volumes',
            description: 'Armazenamento altamente escalável para dados não estruturados, como backups, logs e arquivos multimídia.',
            features: [
              'Acesso global com alta disponibilidade',
              'Integridade e durabilidade garantidas',
              'Integração nativa com aplicações modernas',
              'Otimização de fluxos de trabalho e custos'
            ]
          }
        ]
      },
      security: {
        title: 'Security',
        icon: 'Shield',
        services: [
          {
            name: 'IAM (Identity and Access Management)',
            subtitle: 'Gerenciamento centralizado de identidades',
            description: 'Controle de acesso granular para executar permissões detalhadas para usuários, grupos e recursos.',
            features: [
              'Simplificação de tarefas administrativas',
              'Redução de riscos de segurança',
              'Aumento da eficiência operacional',
              'Gestão unificada facilitando conformidade regulatória'
            ]
          },
          {
            name: 'Automação Inteligente',
            subtitle: 'Apoio efetivo para gestão de acessos',
            description: 'Reduza processos manuais com fluxos automatizados para provisionamento e revogação de acessos.',
            features: [
              'Garantia de conformidade',
              'Minimização de riscos com regras predefinidas',
              'Controle granular de permissões',
              'Integração com sistemas corporativos'
            ]
          },
          {
            name: 'Single Sign-On (SSO)',
            subtitle: 'Acesso unificado com segurança',
            description: 'Autenticação simplificada que permite em um único login o acesso a múltiplos sistemas e aplicações.',
            features: [
              'Redução de riscos com autenticação centralizada',
              'Suporte a MFA (autenticação multifator)',
              'Integração flexível com plataformas empresariais',
              'Experiência de usuário aprimorada'
            ]
          }
        ]
      },
      database: {
        title: 'Database',
        icon: 'Database',
        services: [
          {
            name: 'MySQL',
            subtitle: 'Desempenho e confiabilidade para aplicações',
            description: 'Ideal para aplicações web, mobile e corporativas, garantindo alta performance e escalabilidade.',
            features: [
              'Suporte a transações e replicação',
              'Alta disponibilidade para ambientes críticos',
              'Proteção com criptografia e controle de acessos',
              'Backups automatizados'
            ]
          },
          {
            name: 'PostgreSQL',
            subtitle: 'Banco avançado para alta performance',
            description: 'Adequado para aplicações empresariais que demandam integridade, escalabilidade e segurança.',
            features: [
              'Manipulação avançada de JSON',
              'Índices robustos e extensões para flexibilidade',
              'Replicação e failover automático',
              'Suporte a grandes volumes sem comprometer performance'
            ]
          },
          {
            name: 'SQL Server',
            subtitle: 'Desempenho para cargas empresariais',
            description: 'Suporte a análise de dados, inteligência artificial integrada e processamento transacional eficiente.',
            features: [
              'Failover automático e replicação avançada',
              'Recuperação de desastres para continuidade',
              'Criptografia de dados e autenticação multifator',
              'Conformidade com normas regulatórias'
            ]
          },
          {
            name: 'Oracle',
            subtitle: 'Alto desempenho para projetos corporativos',
            description: 'Suporta altos volumes de dados, utilizando processamento transacional avançado e análise preditiva com IA.',
            features: [
              'Redução de gerenciamento manual',
              'Otimização com aprendizado de máquina',
              'Compatibilidade multinuvem',
              'Escalabilidade eficiente para ambientes híbridos'
            ]
          }
        ]
      },
      network: {
        title: 'Network',
        icon: 'Network',
        services: [
          {
            name: 'VPC (Virtual Private Cloud)',
            subtitle: 'Conectividade segura e isolada',
            description: 'Crie redes privadas dedicadas para suas aplicações, garantindo maior segurança e controle.',
            features: [
              'Integração com redes corporativas e data centers',
              'Integração com outros serviços em nuvem',
              'Configuração de sub-redes, roteamento e firewalls',
              'Controle preciso do fluxo de dados'
            ]
          }
        ]
      }
    },
    
    // Características técnicas principais
    technicalHighlights: [
      {
        title: 'Plataforma IaaS Open-Source',
        description: 'Apache CloudStack é uma plataforma madura e confiável para gestão de infraestrutura como serviço'
      },
      {
        title: 'Multi-Hypervisor',
        description: 'Suporte a KVM, VMware, XenServer e XCP-ng, oferecendo flexibilidade na escolha do hypervisor'
      },
      {
        title: 'Arquitetura Hierárquica',
        description: 'Estrutura escalável: Regions > Zones > Pods > Clusters > Hosts para eficiência operacional'
      },
      {
        title: 'Alta Disponibilidade',
        description: 'SLA de 99.9%+ com DRS para rebalanceamento automático, live migration e VM sync'
      },
      {
        title: 'Auto-Scaling',
        description: 'Escalabilidade automática nativa, operações de ciclo de vida agendadas e manutenção sem downtime'
      },
      {
        title: 'Multi-Tenancy',
        description: 'Isolamento completo de recursos com domínios, projetos, delegação administrativa e LDAP/SAML/2FA'
      },
      {
        title: 'Networking Avançado',
        description: 'VLAN/VXLAN/SDN, VPCs, security groups, firewalls, load balancers Layer-4, VPNs e elastic load balancing'
      },
      {
        title: 'APIs e Integrações',
        description: 'APIs RESTful compatíveis com AWS EC2/S3, integração com Kubernetes (CKS/CAPC), Terraform e Ansible'
      }
    ],
    
    challenges: [
      'Necessidade de maior controle e soberania de dados',
      'Desejo de custos mais previsíveis e redução de dependência de hyperscalers',
      'Provedores/ISPs/hostings que querem ofertar nuvem com marca própria',
      'Demandas de conformidade, personalização e integração com infraestrutura existente'
    ],
    
    deliverables: [
      'Design, instalação e configuração de ambiente cloud',
      'Integração com rede, armazenamento e infraestrutura on-premises',
      'Serviços de VDS gerenciados (monitoramento, backups e suporte)',
      'Customização e suporte técnico especializado'
    ],
    
    whenMakesSense: [
      'ISPs e empresas de hosting que desejam oferta de cloud/VMs com marca própria',
      'Empresas que precisam manter dados em localidade específica',
      'Organizações com necessidades de custos previsíveis e maior controle operacional',
      'Ambientes que exigem isolamento, segmentação e políticas sob medida'
    ],
    
    results: [
      'Controle total de compute, storage e rede com governança personalizada',
      'Custos mais previsíveis',
      'Possibilidade de oferta white-label',
      'Acesso a especialistas em infraestrutura cloud'
    ],

    faq: [
      {
        question: 'Cloud privada é indicada para quais empresas?',
        answer: 'É indicada para empresas que precisam de soberania de dados, custos previsíveis, isolamento, personalização, conformidade ou uma alternativa aos hyperscalers públicos.'
      },
      {
        question: 'A Sua Nuvem também entrega cloud privada white label?',
        answer: 'Sim. A solução pode ser entregue para provedores, ISPs e empresas de hosting que desejam oferecer infraestrutura cloud com marca própria.'
      }
    ]
  },
  
  'finops': {
    id: 'finops',
    title: 'FinOps - Otimização de Custos',
    subtitle: 'Maximize o valor de cada real gasto em nuvem',
    description: 'Implementação de práticas de FinOps para maximizar o valor de cada real gasto em nuvem, unindo times de engenharia, operações e finanças. Entregam visibilidade, governança e rotinas de otimização para AWS, Azure, GCP e cenários híbridos.',
    
    challenges: [
      'Crescimento acelerado e imprevisível da fatura de nuvem',
      'Falta de visibilidade e alocação por time, produto ou centro de custo',
      'Recursos ociosos, dimensionamento inadequado e desperdícios recorrentes',
      'Dificuldade de implementar descontos/compromissos com segurança'
    ],
    
    deliverables: [
      'Diagnóstico de custos com identificação de desperdícios',
      'Dashboards e alertas de orçamento',
      'Rightsizing e otimização de serviços',
      'Estratégia de descontos/compromissos (RIs, Savings Plans)',
      'Políticas de tagging e alocação de custos',
      'Rotina de melhoria contínua e capacitação em FinOps'
    ],
    
    whenMakesSense: [
      'Empresas com gasto relevante em nuvem buscando redução imediata de custos',
      'Negócios em crescimento que precisam de previsibilidade e governança financeira',
      'Ambientes multi-cloud/híbridos com custos distribuídos e baixa transparência',
      'Organizações que querem amadurecer processos e tomadas de decisão baseadas em dados'
    ],
    
    results: [
      'Economia recorrente',
      'Maior previsibilidade do orçamento',
      'Visibilidade clara de custos por produto/projeto/time',
      'Cultura de responsabilidade financeira compartilhada'
    ],

    faq: [
      {
        question: 'FinOps é apenas redução de custos?',
        answer: 'Não. FinOps combina economia, governança, previsibilidade e tomada de decisão baseada em dados para aumentar o valor de cada real investido em nuvem.'
      },
      {
        question: 'Quanto tempo leva para identificar desperdícios?',
        answer: 'Em geral, o diagnóstico inicial já aponta recursos ociosos, superdimensionamento, falta de tagging e oportunidades de compromisso ou automação.'
      }
    ]
  },
  
  'seguranca-devsecops': {
    id: 'seguranca-devsecops',
    title: 'Segurança & DevSecOps',
    subtitle: 'Segurança integrada ao ciclo de vida',
    description: 'Integração de segurança em todas as fases do ciclo de vida de software e operação de infraestrutura, com controles automatizados e foco em conformidade. Trabalham para construir segurança by design em ambientes cloud, on-premises e híbridos.',
    
    challenges: [
      'Riscos crescentes de ataques e exposição de dados',
      'Processos de segurança manuais e tardios',
      'Dificuldade de manter conformidade (LGPD, SOC 2, ISO 27001, PCI DSS)',
      'Gestão complexa de identidade, acesso e segurança em ambientes distribuídos'
    ],
    
    deliverables: [
      'Arquitetura segura e hardening',
      'Integração de SAST, DAST e SCA em pipelines (DevSecOps)',
      'Gestão de identidade e acesso (IAM)',
      'Segurança de containers e Kubernetes',
      'Estratégias de proteção de dados',
      'Plano e apoio em resposta a incidentes'
    ],
    
    whenMakesSense: [
      'Empresas que lidam com dados sensíveis ou requisitos regulatórios',
      'Organizações com operação em nuvem que precisam elevar a postura de segurança',
      'Times de desenvolvimento que querem automatizar controles',
      'Ambientes Kubernetes/containers que precisam de governança e hardening'
    ],
    
    results: [
      'Redução de riscos e diminuição da superfície de ataque',
      'Detecção e mitigação proativa de vulnerabilidades',
      'Conformidade e auditorias facilitadas',
      'Melhoria da confiança de clientes e parceiros'
    ],

    faq: [
      {
        question: 'DevSecOps trava o processo de desenvolvimento?',
        answer: 'Não quando é bem implementado. O objetivo é automatizar controles de segurança no pipeline para identificar riscos cedo, sem depender de revisões manuais tardias.'
      },
      {
        question: 'Quais ambientes podem receber DevSecOps?',
        answer: 'A abordagem pode ser aplicada em cloud pública, cloud privada, ambientes híbridos, Kubernetes, containers, servidores tradicionais e pipelines de aplicação.'
      }
    ]
  },
  
  'observabilidade': {
    id: 'observabilidade',
    title: 'Observabilidade & Monitoramento',
    subtitle: 'Visibilidade fim a fim para reduzir MTTR',
    description: 'Implantação e evolução de observabilidade com correlação de métricas, logs e traces, permitindo identificar causa raiz de incidentes com mais rapidez e melhorar continuamente a experiência do usuário e a estabilidade da plataforma.',
    
    challenges: [
      'Baixa visibilidade e dificuldade de identificar causa raiz em sistemas distribuídos',
      'Demora na detecção e resolução de incidentes (MTTR alto)',
      'Alertas ruidosos e sem contexto',
      'Ausência de indicadores de performance e experiência do usuário'
    ],
    
    deliverables: [
      'Implementação e integração de ferramentas (Prometheus, Grafana, ELK, etc.)',
      'Coleta padronizada de métricas, logs e traces',
      'Dashboards por público',
      'Alertas inteligentes',
      'Runbooks e práticas de resposta a incidentes orientadas por dados',
      'Ajustes contínuos'
    ],
    
    whenMakesSense: [
      'Arquiteturas com microserviços, containers e múltiplas integrações',
      'Sistemas críticos que exigem alta disponibilidade',
      'Empresas com necessidade de indicadores de SLO/SLA',
      'Operações que precisam enxergar custo, performance e confiabilidade de forma integrada'
    ],
    
    results: [
      'Detecção mais rápida de falhas',
      'Redução do tempo de indisponibilidade',
      'Melhoria do MTTR',
      'Maior estabilidade e previsibilidade operacional',
      'Evolução da experiência do usuário'
    ],

    faq: [
      {
        question: 'Qual a diferença entre monitoramento e observabilidade?',
        answer: 'Monitoramento acompanha sinais conhecidos. Observabilidade correlaciona métricas, logs e traces para entender a causa raiz de falhas em sistemas distribuídos.'
      },
      {
        question: 'Observabilidade ajuda em SLA e SLO?',
        answer: 'Sim. Ela permite medir disponibilidade, latência, erros e saturação, apoiando SLOs, alertas mais úteis e resposta a incidentes baseada em dados.'
      }
    ]
  },
  
  'backup-dr': {
    id: 'backup-dr',
    title: 'Backup, Disaster Recovery & Business Continuity',
    subtitle: 'Resiliência e continuidade de negócio',
    description: 'Estratégias de proteção e recuperação para dados e serviços críticos, garantindo resiliência e continuidade de negócio em ambientes multi-cloud e on-premises. Definem RTO/RPO, implementam backups, planos de disaster recovery e testes recorrentes de recuperação.',
    
    challenges: [
      'Risco de perda de dados',
      'Ausência de RTO/RPO definidos e planos de recuperação testados',
      'Backups incompletos ou com restauração lenta',
      'Falta de governança e evidências para conformidade/auditoria'
    ],
    
    deliverables: [
      'Análise de impacto e definição de RTO/RPO',
      'Design e implementação de backup (bancos, VMs, containers, etc.)',
      'Plano de Disaster Recovery (DRP)',
      'Automação de restauração/failover',
      'Testes periódicos de recuperação',
      'Recomendações de armazenamento e retenção'
    ],
    
    whenMakesSense: [
      'Serviços críticos que não podem ficar indisponíveis por longos períodos',
      'Empresas com requisitos de governança, auditoria ou compliance',
      'Ambientes multi-cloud/híbridos que precisam de proteção consistente',
      'Organizações que querem se preparar contra incidentes'
    ],
    
    results: [
      'Redução de riscos e maior confiança na recuperação',
      'Continuidade do negócio com objetivos claros de recuperação',
      'Menor downtime',
      'Conformidade facilitada'
    ],

    faq: [
      {
        question: 'Qual a diferença entre backup e disaster recovery?',
        answer: 'Backup protege dados. Disaster recovery define como recuperar serviços, aplicações, bancos e infraestrutura dentro de objetivos claros de RTO e RPO.'
      },
      {
        question: 'Por que testar restauração periodicamente?',
        answer: 'Porque backups sem teste podem falhar no momento crítico. Testes recorrentes validam integridade, tempo de recuperação e runbooks operacionais.'
      }
    ]
  },
  
  'suporte-sustentacao': {
    id: 'suporte-sustentacao',
    title: 'Suporte & Sustentação',
    subtitle: 'Operação contínua com SLAs e governança',
    description: 'Gestão proativa e reativa da infraestrutura e aplicações para garantir disponibilidade, performance e segurança. Atuam como extensão do time do cliente, com monitoramento contínuo, gestão de incidentes e rotinas de manutenção. O atendimento pode ser 8x5 ou 24/7.',
    
    challenges: [
      'Sobrecarga do time interno',
      'Falta de especialização para ambientes complexos',
      'Necessidade de suporte contínuo com resposta rápida a incidentes',
      'Ambientes com baixa padronização, falta de governança e indicadores',
      'Falta de melhoria contínua'
    ],
    
    deliverables: [
      'Monitoramento proativo e gestão de alertas',
      'Gestão de incidentes',
      'Manutenção preventiva (patches, atualizações)',
      'Gestão de mudanças',
      'Gestão de problemas (análise de causa raiz)',
      'Relatórios periódicos (SLA/SLO, disponibilidade, capacidade, custos)'
    ],
    
    whenMakesSense: [
      'Operações críticas que exigem alta disponibilidade e previsibilidade',
      'Empresas que precisam complementar o time interno com especialistas',
      'Ambientes multi-cloud/híbridos com complexidade operacional elevada',
      'Clientes da Sua Nuvem que desejam suporte especializado'
    ],
    
    results: [
      'Minimização de downtime',
      'Aumento de estabilidade operacional',
      'Maior performance e segurança',
      'Redução de riscos e incidentes recorrentes'
    ],

    faq: [
      {
        question: 'O suporte pode ser 24/7?',
        answer: 'Sim. O atendimento pode ser estruturado em modelo 8x5 ou 24/7, conforme criticidade, SLA e necessidade operacional do ambiente.'
      },
      {
        question: 'A sustentação inclui melhoria contínua?',
        answer: 'Sim. Além de incidentes e manutenção, a operação acompanha capacidade, disponibilidade, segurança, custos e problemas recorrentes.'
      }
    ]
  }
};

export const getServiceById = (id) => servicesData[id] || null;

export const getAllServices = () => Object.values(servicesData);
